export default __webpack_public_path__ + "706f9ebad1738c05307126e5350baa74.svg";